export const actionTypePrefix = '@@ReportPageModal';
export const reduxKey = '@@ReportPageModal';
export var ReportSectionTypes;
(function(ReportSectionTypes) {
    ReportSectionTypes["Home"] = 'home';
    ReportSectionTypes["Inappropriate"] = 'inappropriate';
    ReportSectionTypes["SpamMalwareWarez"] = 'spam-malware-warez';
    ReportSectionTypes["IpViolation"] = 'ip-violation';
    ReportSectionTypes["ThirdPartyIp"] = 'third-party-ip';
    ReportSectionTypes["FirstPartyIp"] = 'first-party-ip';
    ReportSectionTypes["SomethingElse"] = 'something-else';
    ReportSectionTypes["Mature"] = 'mature';
    ReportSectionTypes["Underage"] = 'underage';
    ReportSectionTypes["Explicit"] = 'explicit';
    ReportSectionTypes["Block"] = 'block';
    ReportSectionTypes["Misplaced"] = 'misplaced';
    ReportSectionTypes["Abuse"] = 'abuse';
    ReportSectionTypes["SelfHarm"] = 'self-harm';
    ReportSectionTypes["Spam"] = 'spam';
    ReportSectionTypes["Malware"] = 'malware';
    ReportSectionTypes["Warez"] = 'warez';
    ReportSectionTypes["MonetizedAi"] = 'monetized-ai';
})(ReportSectionTypes || (ReportSectionTypes = {}));
export const ReportSectionForms = {
    [ReportSectionTypes.ThirdPartyIp]: 30,
    [ReportSectionTypes.FirstPartyIp]: 39,
    [ReportSectionTypes.Mature]: 4,
    [ReportSectionTypes.Underage]: 28,
    [ReportSectionTypes.Explicit]: 37,
    [ReportSectionTypes.Misplaced]: 2,
    [ReportSectionTypes.Abuse]: 3,
    [ReportSectionTypes.SelfHarm]: 45,
    [ReportSectionTypes.Spam]: 44,
    [ReportSectionTypes.Malware]: 32,
    [ReportSectionTypes.Warez]: 33,
    [ReportSectionTypes.MonetizedAi]: 46
};
